module.exports = __webpack_public_path__ + "static/media/29COICT9.359b3d28.jpg";